import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { IStudyFilters, IStudyPayload } from "../models/interfaces";
import { permanentDeleteStudy } from "../serviceHelper";
import { IPermanentDeletePayload } from "../models/interfaces";

const initialState = {
	tableLoading: false,
	studiesPayload: {
		currentPage: 1,
		pageSize: 10,
		totalPages: null,
		studiesData: [],
	},
	studiesFilter: {
		search: null,
		selectedFilters: [],
		selectedStudyTypes: [],
		isProfileFiltered: false,
		isStudyTypeFiltered: false,
		sort_ascending: null,
	},
	isPermanentDeleting: false,
	permanentDeleteError: null as string | null,
};

export const permanentDeleteStudyThunk = createAsyncThunk(
	"studyManagement/permanentDeleteStudy",
	async (payload: IPermanentDeletePayload, { rejectWithValue }) => {
		try {
			const res = await permanentDeleteStudy(payload);
			return { studyId: payload.study_id, response: res };
		} catch (err: any) {
			return rejectWithValue(err?.message ?? "Permanent deletion failed");
		}
	}
);

const studyManagementSlice = createSlice({
	name: "studyManagement",
	initialState,
	reducers: {
		setTableLoading: (state, action: PayloadAction<boolean>) => {
			state.tableLoading = action.payload;
		},
		setStudiesPayload: (state, action: PayloadAction<IStudyPayload>) => {
			state.studiesPayload = action.payload;
		},
		setStudiesFilter: (state, action: PayloadAction<IStudyFilters>) => {
			state.studiesFilter = action.payload;
		},
		setStudyCollaborators: (state, action: PayloadAction<{ collaborators: any; study_id: string }>) => {
			const { study_id, collaborators } = action.payload;
			state.studiesPayload.studiesData = state.studiesPayload.studiesData.map((study) => {
				if (study.study_id === study_id) {
					study.study_collaborators = collaborators;
				}
				return study;
			});
		},
		setPermanentDeleteError: (state, action: PayloadAction<string | null>) => {
			state.permanentDeleteError = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(permanentDeleteStudyThunk.pending, (state) => {
				state.isPermanentDeleting = true;
				state.permanentDeleteError = null;
			})
			.addCase(permanentDeleteStudyThunk.fulfilled, (state, action) => {
				state.isPermanentDeleting = false;
				state.studiesPayload.studiesData = state.studiesPayload.studiesData.filter(
					(study) => study.study_id !== action.payload.studyId
				);
			})
			.addCase(permanentDeleteStudyThunk.rejected, (state, action) => {
				state.isPermanentDeleting = false;
				state.permanentDeleteError = action.payload as string;
			});
	},
});

export const { setTableLoading, setStudiesPayload, setStudiesFilter, setStudyCollaborators, setPermanentDeleteError } =
	studyManagementSlice.actions;

export default studyManagementSlice.reducer;
